<template>
  <Modal
    v-model:visible="isVisible"
    class="batch-update-shipment-health-modal"
    content-class="flex flex-column flex-gap-1"
    :header="t('common.updateParam', { param: t('shipments.health') })"
    @keyup.esc="isVisible = false"
    @show="onShow"
  >
    <p id="select-health-paragraph">
      {{ t('batchAction.selectHealth') }}
    </p>

    <InputWrapper
      v-slot="{ ariaProps, inputId }"
      input-id="batch-update-shipment-health-input"
      :label="t('shipments.health')"
    >
      <RygenDropdown
        :id="inputId"
        v-model="selectedHealth"
        v-bind="ariaProps"
        class="w-full"
        append-to="body"
        aria-describedby="select-health-paragraph"
        option-label="label"
        option-value="value"
        :options="healthOptions"
        :placeholder="t('common.chooseParam', { param: t('shipments.health') })"
      />
    </InputWrapper>

    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.cancel')"
        @click="isVisible = false"
      />
      <RygenButton
        mode="primary"
        icon="pi pi-save"
        :disabled="!selectedHealth"
        :label="t('common.saveParam', { param: t('shipments.health') })"
        @click="onSave"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';

import { ShipmentHealth } from '@/model';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenDropdown from '@rygen/rygen-ui/components/form/RygenDropdown.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const emit = defineEmits<{
  (event: 'save', health: ShipmentHealth): void;
}>();

const { t } = useI18n();

const healthOptions = mapEnumToTranslatedDropdownValues(
  ShipmentHealth,
  'ShipmentHealth',
);
const selectedHealth = ref<ShipmentHealth>();

const onShow = () => {
  selectedHealth.value = undefined;
};

const onSave = () => {
  if (!selectedHealth.value) {
    return;
  }

  emit('save', selectedHealth.value);
  isVisible.value = false;
};
</script>
